import FiltersSection, { FiltersSectionProps } from "./filters-section/FiltersSection";
import SearchResultsSection from "./search-results-section/SearchResultsSection";
import { useState } from "react";
import { extractDefaultFilterValues } from "@kaltura/mediaspace-shared-utils";
import { FilterValues } from "@kaltura/mediaspace-shared-types";
import styled from "@emotion/styled";

const StyledContentContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}));

export interface ChannelsGridProps extends Pick<FiltersSectionProps, "filters"> {
    /**
     * initial filter values
     */
    initialValues?: FilterValues;

    /**
     * should reflect selected filters in query string
     * default: true
     * if false, the query string will not be updated when filters change
     * this is useful when the component is used in a context where the query string is not relevant (e.g. gallery channels tab)
     */
    reflectSelectedFiltersInQueryString?: boolean;
}

export const ChannelsGrid = (props: ChannelsGridProps) => {
    const { filters, initialValues, reflectSelectedFiltersInQueryString = true } = props;

    // filter values as the user set them (+ defaults)
    const [filterValues, setFilterValues] = useState(() => {
        return { ...extractDefaultFilterValues(filters), ...initialValues };
    });

    // handle submit search form
    const handleKeywordSearchSubmit = (value: string) => {
        setFilterValues((filterValues) => ({
            ...filterValues,
            keyword: value,
        }));
    };

    // handle filter change
    const handleFilterChange = (values: FilterValues) => {
        setFilterValues(values);
    };

    return (
        <StyledContentContainer>
            <FiltersSection
                filters={filters}
                filterValues={filterValues}
                onKeywordSubmit={handleKeywordSearchSubmit}
                onFilterChange={handleFilterChange}
                reflectSelectedFiltersInQueryString={reflectSelectedFiltersInQueryString}
            />
            <SearchResultsSection filterValues={filterValues} />
        </StyledContentContainer>
    );
};
